import {IsInt, IsEmail, IsString, IsDateString, IsNumber, IsDate,IsAlphanumeric, MaxLength, Matches, IsOptional, IsNotEmpty, ValidateNested, isNotEmpty } from 'class-validator';
import { ApiProperty } from '@nestjs/swagger';

export class MandalDTO {
    
    @ApiProperty()
    Id?: number;
    @ApiProperty()
    mandalCode:string;
    @ApiProperty()
    @IsNotEmpty()
    @MaxLength(500,{ message: "Mandal name not empty"})
    mandalName:string; 
    @ApiProperty()
    districtId:number;   
    // @ApiProperty()
    // stateId : number;
    @ApiProperty()
    status: boolean;
    createdAt : Date;
    @ApiProperty()
    @IsOptional()
    createdUser : number;
    updatedAt : Date;
    @ApiProperty()
    @IsOptional()
    updatedUser : number;
    @ApiProperty()
    versionFlag : number;
}

export class MandalStatusDTO {
    @ApiProperty()
    Id?: number;
    @ApiProperty()
    status: boolean;
    updatedAt : Date;
    @ApiProperty()
    @IsOptional()
    updatedUser : number;
}
export class getdistrictDTO {
  
    @ApiProperty()
    @IsNotEmpty({message:"districtId should not be empty"})
    districtId:number;
    
}

